<template>
  <CModal
    :show.sync="viewPollQuestionModal"
    :centered="true"
    title="مشاهده سوال"
    size="md"
  >
    <div class="text-right">
      <div class="desc text-sm">{{ question.text }}</div>
<div class="mt-3">گزینه ها:</div>
      <ul>
        <li v-for="(choice, index) in question.choices" :key="index" v-show="choice.length" class="mt-2">{{choice}}
        </li>
      </ul>
    </div>

    <template #footer>
      <CButton @click="viewPollQuestionModal = false" color="danger">بستن</CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    question: {
      type: Object,
    },
  },
  computed: {
    viewPollQuestionModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.desc {
  word-wrap: break-word;
  white-space: pre-line;
  font-size: 14px;
  line-height: 1.5;
}
</style>
